import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { FormArray, FormControl, FormGroup } from '@angular/forms';
import { IApiResponse2 } from '@interfaces/api-response.interface';
import { ISchemeResponse } from 'app/pages/panel/schemes-responses/schemes-responses.interface';
import { environment } from 'environments/environment';
import { ISchemeResponseListFilter } from './scheme-responses-list.interface';

@Injectable({
  providedIn: 'root',
})
export class SchemeResponsesListService {
  private http = inject(HttpClient);

  formFilterList = new FormGroup({
    startDate: new FormControl(''),
    endDate: new FormControl(''),
    groupReferences: new FormArray<FormControl<string>>([]),
    status: new FormArray<FormControl<string>>([]),
    step: new FormArray<FormControl<string>>([]),
    page: new FormControl(0),
    size: new FormControl(15),
    document: new FormControl(''),
    groupReference: new FormControl(''),
    typeSchema: new FormControl(''),
    columnsQuestionCode: new FormControl(''),
    headersValue: new FormControl(''),
    sortField: new FormControl(''),
    sortDirection: new FormControl(''),
    responsibleUserId: new FormControl(''),
    schemeName: new FormControl(''),
    dueDateStart: new FormControl(''),
    dueDateEnd: new FormControl(''),
    customerId: new FormControl(''),
    enterpriseCode: new FormControl(''),
    customerCode: new FormControl(''),
    substitute: new FormControl(false)
  });

  list() {
    const filters = this.formFilterList.getRawValue() as ISchemeResponseListFilter;
    let params = new HttpParams().set('page', filters.page).set('size', filters.size);

    if (filters.sortField) {
      params = params.set('sortField', filters.sortField);
    }
    if (filters.responsibleUserId) {
      params = params.set('responsibleUserId', filters.responsibleUserId);
    }
    if (filters.sortDirection) {
      params = params.set('sortDirection', filters.sortDirection);
    }
    if (filters.groupReference) {
      params = params.set('groupReference', filters.groupReference);
    }
    if (filters.typeSchema) {
      // params = params.set('typeSchema', filters.typeSchema);
    }
    if (filters.document) {
      params = params.set('document', filters.document);
    }
    if (filters.step) {
      filters.step.forEach(step => {
        params = params.append('step', step);
      });
    }
    if (filters.status) {
      filters.status.forEach(status => {
        params = params.append('status', status);
      });
    }
    if (filters.startDate) {
      params = params.set('startDate', filters.startDate);
    }
    if (filters.endDate) {
      params = params.set('endDate', filters.endDate);
    }
    if (filters.columnsQuestionCode) {
      params = params.set('columnsQuestionCode', filters.columnsQuestionCode);
    }
    if (filters.headersValue) {
      params = params.set('headersValue', filters.headersValue);
    }
    if (filters.dueDateStart) {
      params = params.set('dueDateStart', filters.dueDateStart);
    }
    if (filters.dueDateEnd) {
      params = params.set('dueDateEnd', filters.dueDateEnd);
    }
    if (filters.customerId) {
      params = params.set('customerId', filters.customerId);
    }
    if (filters.substitute) {
      params = params.set('substitute', filters.substitute);
    }
    if (filters.enterpriseCode) {
      params = params.set('enterpriseCode', filters.enterpriseCode);
    }

    if (filters.groupReferences) {
      let groupReferences = '';
      filters.groupReferences.forEach((reference, index) => {
        if (index !== filters.groupReferences.length - 1) {
          groupReferences += `${reference},`;
        } else {
          groupReferences += reference;
        }
      });
      params = params.append('groupReferences', groupReferences);
    }

    const http = {
      headers: new HttpHeaders({
        Authorization: sessionStorage.getItem('token') as string,
      }),
      params,
    };

    return this.http
      .get<IApiResponse2<ISchemeResponse>>(
        `${environment.api}/api/form-group-responses/step-search`,
        http
      )
      .pipe(
        (res) => res,
        (error) => error
      );
  }

  duplicateSchema(id: string) {
    const http = {
      headers: new HttpHeaders({
        Authorization: sessionStorage.getItem('token') as string,
        'Access-Control-Allow-Origin': '*',
        'Content-Type': 'application/json'
      }),
    };

    return this.http.post(`${environment.api}/api/form-group-responses/clone-form-group-response/${id}`, {}, http).pipe(
      (res) => res,
      (error) => error
    );
  }

  getResponseByIdAndQuestionCode(responseId: string, questionCode: string) {
    const http = {
      headers: new HttpHeaders({
        Authorization: sessionStorage.getItem('token') as string,
      }),
    };
    return this.http.get(`${environment.api}/form-response-model/get-by-question-code-and-response-id?formGroupId=${responseId}&code=${questionCode}`, http).pipe(
      (res) => res,
      (error) => error
    );
  }

  export() {
    let params = new HttpParams()
    const filters = this.formFilterList.getRawValue() as ISchemeResponseListFilter;
    if (filters.dueDateStart) {
      params = params.set('dueDateStart', filters.dueDateStart);
    }
    if (filters.dueDateEnd) {
      params = params.set('dueDateEnd', filters.dueDateEnd);
    }
    if (filters.startDate) {
      params = params.set('startDate', filters.startDate);
    }
    if (filters.endDate) {
      params = params.set('endDate', filters.endDate);
    }
    if (filters.groupReference) {
      params = params.set('groupReference', filters.groupReference);
    }
    if (filters.groupReferences) {
      let groupReferences = '';
      filters.groupReferences.forEach((reference, index) => {
        if (index !== filters.groupReferences.length - 1) {
          groupReferences += `${reference},`;
        } else {
          groupReferences += reference;
        }
      });
      params = params.append('groupReferences', groupReferences);
    }

    if (filters.columnsQuestionCode) {
      params = params.set('columnsQuestionCode', filters.columnsQuestionCode);
    }
    if (filters.headersValue) {
      params = params.set('headersValue', filters.headersValue);
    }
    if (filters.document) {
      params = params.set('document', filters.document);
    }
    if (filters.responsibleUserId) {
      params = params.set('responsibleUserId', filters.responsibleUserId);
    }
    if (filters.status) {
      filters.status.forEach(status => {
        params = params.append('status', status);
      });
    }
    if (filters.step) {
      filters.step.forEach(step => {
        params = params.append('step', step);
      });
    }
    if (filters.substitute) {
      params = params.set('substitute', filters.substitute)
    }

    const http = {
      headers: new HttpHeaders({
        Authorization: sessionStorage.getItem('token') as string,
      }),
      params,
    };

    return this.http.get<any>(`${environment.api}/api/form-group-responses/step-search/xlsx`, http).pipe(
      (res) => res,
      (error) => error,
    );
  }

  downloadZip(id: string) {
    const http = {
      headers: new HttpHeaders({
        Authorization: sessionStorage.getItem('token') as string,
      }),
      responseType: 'blob' as 'json',
    };

    return this.http.get<any>(`${environment.api}/api/form-group-responses/${id}/export-files`, http).pipe(
      (res) => res,
      (error) => error
    );
  }
}
